@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="d-flex flex-wrap justify-content-between">
        <div class="flex-grow-1 titulo_texto_posicao">
          <div class="titulo_texto">Call Center - Motivos (Pausa)</div>
        </div>
        <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
          <a class="btn btn-secondary btn_titulo" routerLink="/call-center-motivos-pausa-cadastro">Novo Motivo</a>
        </div>
      </div>
    </div>
    <!-- Dados -->
    <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="tabela_lg" [itemSize]="20">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th></th>
                <th class="tabela_borda">Motivo</th>
                <th class="text-center tabela_borda">Ativo</th>
                <th class="text-center tabela_borda">Somente Gestor</th>
                <th class="text-center tabela_borda">Tempo</th>
              </tr>
            </thead>
            <tbody>
              <tr *cdkVirtualFor="let motivoPausa of motivosPausa; templateCacheSize: 0;">
                <td class="text-center tabela_acao">
                  <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="alterarMotivo(motivoPausa.id)"></i>
                </td>
                <td class="tabela_borda">{{ motivoPausa.nome }}</td>
                <td class="text-center tabela_borda">{{ motivoPausa.is_active ? 'Sim' : 'Não' }}</td>
                <td class="text-center tabela_borda">{{ motivoPausa.flag_somente_gestor ? 'Sim' : 'Não' }}</td>
                <td class="text-center tabela_borda">{{ motivoPausa.tempo_pausa }}</td>
              </tr>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </div>
}
